<template lang="pug">
  .columnMapping
    .row
      .col-6
        select(v-model="mapping.code" @change="userDidSelectMappingType()").w-100.customInput.px-2
          option(v-for="columnMapping in columnMappings", :value="columnMapping.code") {{columnMapping.name}}
      .col-6(v-if="syncDirection == 'in'")
        input(type="text", v-model="mapping.columnIndexOrName").w-100.customInput
    .row.mt-2
      .col-12
        button(@click="showSettings=true" v-if="!showSettings").customButton Show more settings 
        button(@click="showSettings=false" v-if="showSettings").customButton Hide more settings 
        button(@click="$emit('delete-user-mapping', index)").customButton.btn-danger.ml-2  Delete mapping
    .row.mt-4(v-if="showSettings")
      .settings(v-if="mapping.settings && mapping.settings.length > 0").col-12
        .row
          .col-12 Settings
          .col-12.mt-2
            .row(v-for="setting in mapping.settings")
              .col-12 
                InputComponent(v-bind:inputObject="setting", :ref="setting.code")

      .col-12.mt-2 Rules
      .col-12.mt-3
        button(@click="addRule()").customButtonLinear + Add rule
      .col-12.mt-2
        .row(v-for="(rule, ruleIndex) in mapping.rules", v-bind:key="ruleIndex").d-flex.align-items-end
          .col-2
            InputComponent(v-bind:inputObject="rule.fromRuleType" :ref="rule.fromRuleType.code")
          .col-3
            InputComponent(v-bind:inputObject="rule.fromRuleValue" :ref="rule.fromRuleValue.code")
          .col-3
            InputComponent(v-bind:inputObject="rule.toRuleType" :ref="rule.toRuleType.code")
          .col-3
            InputComponent(v-if="showToRuleValue(ruleIndex)" v-bind:inputObject="rule.toRuleValue" :ref="rule.toRuleValue.code")
          .col-1
            button(@click="deleteRule(ruleIndex)").customButton.btn-danger Delete rule
</template>

<script>
import {InputComponent} from './../'
import { Validation } from '@/helpers';
import _ from 'lodash'

export default {
  name: 'SingleColMappingComponent',
  props:{
    mapping: Object,
    columnMappings: Array,
    index: Number,
    syncDirection: String
  },
  components: {
      InputComponent
  },
  data() {
    return {
      showSettings: false
    }
  },
  mounted() {
  },
  methods: {
      userDidSelectMappingType(){
        const newMapping = this.columnMappings.find(x => x.code == this.mapping.code);
        this.mapping.code = newMapping.code;
        this.mapping.name = newMapping.name;
        this.mapping.columnIndexOrName = newMapping.columnIndexOrName;
        this.mapping.settings = newMapping.settings
        this.mapping.rules = []
      },
      addRule(){
        const rules = _.cloneDeep(this.columnMappings.find(x => x.code == this.mapping.code).rules)
        this.mapping.rules.push(rules[0])
      },
      deleteRule(index){
        this.mapping.rules.splice(index, 1);
      },
      validate(){
        return Validation.validateFromRefs(this.$refs)
      },
      showToRuleValue(ruleIndex){
        let res = false;
        const ruleTypes = this.mapping.rules[ruleIndex].toRuleType.options;
        const selectedType = this.mapping.rules[ruleIndex].toRuleType.selectedValue;
        ruleTypes.forEach((ruleType) => {
          if(ruleType.code == selectedType && ruleType.showToRuleValues){
            res = true;
          }
        })
        return res;
      } 
  },
  computed: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less'); 
   .nav-tabs {
       a {
           color: #4a4a4a;
       }
       .active {
           color: @primary !important;
       }
   }
   .title {
       font-weight: bold;
   }
</style>
